import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumLicenses as LogoLicenses } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/licenses/_list')({
  component: LicensesLayout
});
function LicensesLayout() {
  const {
    t
  } = useTranslation();
  useDocumentTitle(t('pages.licenses.title'));
  const tabs = [{
    to: '/licenses',
    children: t('common.list.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/licenses/inventory',
    children: t('common.list.licenses.inventory')
  }, {
    to: '/licenses/people',
    children: t('common.list.people')
  }, {
    to: '/licenses/alerts',
    children: t('common.list.alerts')
  }, {
    to: '/licenses/contract-and-cost',
    children: t('common.list.contractAndCost')
  }, {
    to: '/licenses/operation-activity',
    children: t('common.list.operationActivity')
  }, {
    to: '/licenses/rule-and-policy',
    children: t('common.list.ruleAndPolicy')
  }, {
    to: '/licenses/settings',
    children: t('common.list.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoLicenses} name={t('pages.licenses.title')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}